import { paletteFor, pillarSlug } from '../../lib/briefModel.js';
import BriefArticleCard from './BriefArticleCard.jsx';

export default function BriefPillarSection({ section, isFirstSection }) {
  const palette = paletteFor(section.category);
  const slug = pillarSlug(section.category);

  return (
    <section id={slug} className="scroll-mt-28 mb-12">
      <div className="border-t-[6px] border-black pt-6 mb-7">
        <div className="flex gap-5 sm:gap-6">
          <div
            className="w-4 sm:w-5 shrink-0"
            style={{ backgroundColor: palette.bar }}
            aria-hidden="true"
          />
          <div className="min-w-0 flex-1">
            <h2 className="font-sans font-black text-[34px] sm:text-[40px] lg:text-[44px] leading-[0.95] uppercase text-black tracking-tight m-0 mb-3">
              {section.category}
            </h2>
            {section.tagline ? (
              <p className="font-sans text-[16px] sm:text-[17px] leading-snug text-[#525252] font-medium max-w-3xl m-0">
                {section.tagline}
              </p>
            ) : null}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4 mb-8">
        <div className="flex-1 border-b border-[#D4D4D4]" aria-hidden="true" />
        <span className="font-mono text-[12px] tracking-[0.28em] uppercase text-[#737373] font-bold">
          The Stories
        </span>
        <div className="flex-1 border-b border-[#D4D4D4]" aria-hidden="true" />
      </div>

      <div>
        {section.articles.map((article, i) => (
          <BriefArticleCard
            key={article.articleId || article.number}
            article={article}
            palette={palette}
            isTopStory={isFirstSection && i === 0}
          />
        ))}
      </div>
    </section>
  );
}
